import React, { useEffect, useState } from 'react';
import { Empty, message } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import './SurveyResult.less';
import footerLogo from '../../../assets/img/footer_logo_black.png';
import resultLogo from '../../../assets/img/result_logo.png';
import { getQueryString } from '../../../utils/utils';
import { surveyInfoApi, templateDetailApi } from '../api';

let timer: any = null;

// 问卷提交结果
const SurveyResult: React.FC = () => {
    const navigate = useNavigate();
    const params = useParams();
    const [endPage, setEndPage] = useState<string>();
    const [isEndPage, setIsEndPage] = useState<number>(0);
    const [isShowPage, setIsShowPage] = useState(false);

    const init = () => {
        timer = setTimeout(() => {
            navigate(-1);
            clearTimeout(timer);
        }, 3000);
    };

    // 获取问卷基本信息
    const getSurveyInfo = async () => {
        const res: any = await surveyInfoApi({ id: params?.id });
        if (res.status_code === 200) {
            setEndPage(res.data.endPage);
            setIsEndPage(res.data.isEndPage);
            document.title = res.data.name || '医调研';
            setIsShowPage(true);
            if (res.data?.status === 2 && !getQueryString('boss')) {
                message.error('该问卷已下架，感谢您的参与。');
                navigate(`/s/error?type=${2}`, { replace: true });
                return;
            }
        }
    };

    // 获取模板基本信息
    const getTemplateInfo = async () => {
        const res: any = await templateDetailApi({ id: params?.id });
        if (res.status_code === 200) {
            setEndPage(res.data.endPage);
            setIsEndPage(res.data.isEndPage);
            setIsShowPage(true);
        }
    };

    useEffect(() => {
        if (getQueryString('type')) {
            init();
        }

        if (getQueryString('template')) {
            getTemplateInfo();
        } else {
            getSurveyInfo();
        }

        return () => {
            timer && clearTimeout(timer);
        };
    }, []);

    if (!isShowPage) return null;

    return (
        <div className="survey-result">
            {isEndPage && endPage ? <div className="result-page" dangerouslySetInnerHTML={{ __html: endPage }}></div> : <Empty description={<span className="title">感谢您的参与</span>} image={resultLogo}></Empty>}
            {!getQueryString('type') ? (
                <div className="survey-footer">
                    <img src={footerLogo} alt="" />
                    <p className="footer-text">
                        <span>健康界 版权所有 All Rights Reserved.</span>
                        <span>北京华媒康讯信息技术股份有限公司</span>
                    </p>
                </div>
            ) : null}
        </div>
    );
};

export default SurveyResult;
